import { setting_obj } from '@/settings/setting';

const prefix = `${setting_obj.cmsCdnPath}/MGwebsite`;

/**
 * @description: 获取plugin详情的 seo 的TDK
 * @param {*} params
 * @param {*} axios
 * @return {*}
 */
export function getPluginTDK(id, axios) {
  if (!axios || !id) return {};
  return axios
    .$get(`${prefix}/plugin-seo/${id}.json`)
    .then((res) => res)
    .catch(() => ({}));
}
